module.exports = __webpack_public_path__ + "static/media/20ECE30.9ebc6f3d.jpg";